import React, { ChangeEvent } from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { searchBikeAPI } from "../../Services/BikeService";
import "./BikeSearch.css";
import Form from 'react-bootstrap/Form';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";


interface Props {searchBike: (make: string, model: string, year: string) => void;
  getModelOptions: (make: string) => void;
  getYearOptions: (year: string) => void;
  makeOptions: { bike_col: string; }[];
  modelOptions: { bike_col: string; }[];
  yearOptions: { bike_col: string; }[];
}

type BikeSearchFormsInputs = {
  make: string;
  model: string;
  year: string;
};

const validation = Yup.object().shape({
  make: Yup.string().required("Make is required"),
  model: Yup.string().required("Model is required"),
  year: Yup.string().required("Year is required"),
});



const BikeSearch = ({searchBike, getModelOptions, getYearOptions, makeOptions, modelOptions, yearOptions}: Props) => {
    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm<BikeSearchFormsInputs>({ resolver: yupResolver(validation) });
  
    const handleSearchBike = (form: BikeSearchFormsInputs) => {
      searchBike(form.make, form.model, form.year);
    };

    const handleMakeChange = (event: ChangeEvent<HTMLSelectElement>) => {
      getModelOptions(event.target.value);
    };

    const handleYearChange = (event: ChangeEvent<HTMLSelectElement>) => {
      getYearOptions(event.target.value);
    };


  return (
    <section className="bike-search">
      <Container className="shadow rounded bg-white">
        <Row className="justify-content-md-center">
          <div className="container text-center mt-4">
            <h1 className="mb-4">Find Your Bike</h1>
            <form onSubmit={handleSubmit(handleSearchBike)}>
              <div className="row justify-content-center">
                <div className="col-md-3 text-left">
                  <label className="form-label d-block text-start">Make</label>
                  <select className="form-select" {...register("make")} onChange={handleMakeChange}>
                    <option value="">Please select</option>
                    {makeOptions.map((make) => (
                    <option key={make.bike_col} value={make.bike_col}>{make.bike_col}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <Form.Label className="form-label d-block text-start">Model</Form.Label>
                  <select className="form-select" {...register("model")} onChange={handleYearChange}>
                    <option value="">Please select</option>
                    {modelOptions.map((model) => (
                    <option key={model.bike_col} value={model.bike_col}>{model.bike_col}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <Form.Label className="form-label d-block text-start">Year</Form.Label>
                  <select className="form-select" {...register("year")}>
                    <option value="">Please select</option>
                    {yearOptions.map((year) => (
                    <option key={year.bike_col} value={year.bike_col}>{year.bike_col}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="row justify-content-center mt-3">
                <div className="col-md-9">
                  <Button type="submit" className="btn btn-primary w-100 mt-4 mb-4">Search</Button>
                </div>
              </div>
            </form>
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default BikeSearch;
